import { Describe, lazy, nullable, record, string } from "superstruct";

export type I18nScriptTagRecords = {
    [key: string]: string | null;
};

export const I18nScriptTagRecordsSchema: Describe<I18nScriptTagRecords> = lazy(
    () => record(string(), nullable(string()))
);
